<template>
  <v-container class="py-0 px-1">
      <v-form ref="filtroBuscaForm">
        <v-row>
          <!-- <v-spacer></v-spacer> -->
            <v-col class="px-2 pb-2" cols="2">
                <label>Data entre</label>
                <v-menu
                    ref="dtI"
                    v-model="dtI"
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                    class="mb-2"
                    >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="dateIFormatted"
                        dense
                        v-mask="'##/##/####'"
                        format="DD/MM/YYYY"
                        placeholder="DD/MM/YYYY"
                        label
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar-blank"
                        @blur="dateI = parseDate(dateIFormatted)"
                        :rules="[formRules.typeDateFormated, dateIFormatted || dateFFormatted ? true : 'Campo obrigatório']"
                    ></v-text-field>
                    </template>
                    <v-date-picker color="primary"  v-model="dateI" no-title scrollable></v-date-picker>
                </v-menu>
            </v-col>
            <v-col class="px-2 pb-2" cols="2">
                <label>até</label>
                <v-menu
                    ref="dtF"
                    v-model="dtF"
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="dateFFormatted"
                        v-mask="'##/##/####'"
                        format="DD/MM/YYYY"
                        placeholder="DD/MM/YYYY"
                        label
                        dense
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar-blank"
                        @blur="dateF = parseDate(dateFFormatted)"
                        :rules="[formRules.typeDateFormated, dateIFormatted || dateFFormatted ? true : 'Campo obrigatório']"
                    ></v-text-field>
                    </template>
                    <v-date-picker color="primary"  v-model="dateF" no-title scrollable></v-date-picker>
                </v-menu>
            </v-col>
            <v-col class="px-2 pb-2" cols="2" v-show="parametros && parametros.FAT_TIPO_TITULO">
            <label>Tipo</label>
            <v-select
                v-model="typeSearch"
                :items="typeSearchList"
                item-value="id"
                item-text="descricao"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
                @change="formData.numero = null; formData.nr_titulo = null; search = null"
            ></v-select>
            </v-col>
            <v-col class="px-2 py-8" cols="2" v-show="parametros && parametros.FAT_TIPO_TITULO">
                <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                :placeholder="typeSearch == 1 ?'Número Nota' :typeSearch == 2 ?'Número Título' :null"
                single-line
                outlined
                dense
                hide-details
                :disabled="typeSearch == null"
                @input="typeSearch == 1 ? formData.numero = search :typeSearch == 2 ?formData.nr_titulo = search :null"
            ></v-text-field>
            </v-col>
            
            <v-col class="px-2 py-8 pb-2" cols="4">
                <v-btn
                    small 
                    height="32px"
                    color="primary"
                    class="px-2 mr-3"
                    depressed
                    @click="sendFilter()"
                    >Filtrar</v-btn>
                <v-btn
                    outlined
                    small 
                    height="32px"
                    color="primary"
                    class="px-2 ml-1"
                    depressed
                    @click="clearFilters()"
                    >Limpar Filtro</v-btn>
            </v-col>
        </v-row>
      </v-form>
  </v-container>
</template>

<script>
import { mapState } from "vuex"
export default {
    data() {
        return{
            formData: {
                tipo: null,
                data_ate: null,
                data_entre: null,
                numero: null,
                nr_titulo: null
            },
            dtI: false,
            dateI:null,
            dateIFormatted: null,
            dtF: false,
            dateF: null,
            dateFFormatted: null,
            typeSearchList: [
                {id: null, descricao: "Selecione"},
                {id: 1, descricao: "Notas"},
                {id: 2, descricao: "Títulos"}
            ],
            typeSearch: null,
            search: null,
        }
    },
    computed: {
        ...mapState({
            formRules: state => state.formRules
        }),
    },  
    watch: {
        parametros(val){
            if(val && !val.FAT_TIPO_TITULO)
                this.tipo = 1
        },
        dateF(val){
          if (!val) {
            this.dateFFormatted = null
          } else {
            if (!!this.dateI && Date.parse(this.dateI) > Date.parse(val)){
              this.dateI = val
            }
            this.dateFFormatted = this.formatDate(val)
          }
        },
        dateFFormatted(val){
          this.formData.data_ate = this.parseDate(val)
        },
        dateI(val){
          if (!val) {
            this.dateIFormatted = null
          } else {
            if (!!this.dateF && Date.parse(this.dateF) < Date.parse(val)){
              this.dateF = val
            }
            this.dateIFormatted = this.formatDate(val)
          }
        },
        dateIFormatted(val){
          this.formData.data_entre = this.parseDate(val)
        },
        limpaFiltros(val){
            if(val){
                this.clearFilters()
            }
        }
    },
    mounted() {
       
    },
    methods: {
        clearFilters(){
            this.formData.data_entre = null
            this.formData.data_ate = null
            this.formData.tipo= null
            this.formData.numero= null
            this.formData.nr_titulo= null
            this.dateIFormatted = null
            this.dateFFormatted = null
            this.dateI = null
            this.dateF = null
            this.$refs.filtroBuscaForm.resetValidation()
            this.limpar()
        },
        sendFilter(){
            if(this.$refs.filtroBuscaForm.validate()){
                this.filtrarDoc(this.formData)
            }
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            let [day, month, year] = date.split("/");
            return `${year}-${month}-${day}`;
        },
    },
    props: {
        filtrarDoc: Function,
        parametros:Object,
        limpar: Function,
        limpaFiltros: Boolean
    }
}
</script>

<style>
</style>